import React from 'react';

class ListItemThongKeThanhTraChuyenNganh extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    let Item = this.props.item || {};
    return (
      <tr className={this.props.sum ? 'txt-bold' : ''}>
        <td className='column-stt-fixed'>{this.props.count}</td>
        <td className='column-name-fixed'>{Item.donVi ? Item.donVi.ten : (Item.capDonVi ? Item.capDonVi.ten : '')}</td>
        <td className='txt-center'>{Item.tongSo ? Item.tongSo : 0}</td>
        <td className='txt-center'>{Item.thanhLapDoan ? Item.thanhLapDoan : 0}</td>
        <td className='txt-center'>{Item.thanhTraDocLap ? Item.thanhTraDocLap : 0}</td>

        <td className='txt-center'>{Item.caNhanDuocThanhTra ? Item.caNhanDuocThanhTra :0}</td>
        <td className='txt-center'>{Item.caNhanDuocKiemTra ? Item.caNhanDuocKiemTra : 0}</td>
        <td className='txt-center'>{Item.toChucDuocThanhTra ? Item.toChucDuocThanhTra : 0}</td>
        <td className='txt-center'>{Item.toChucDuocKiemTra ? Item.toChucDuocKiemTra : 0}</td>
        <td className='txt-center'>{Item.soCoViPhamTongSo ? Item.soCoViPhamTongSo : 0}</td>

        <td className='txt-center'>{Item.soCoViPhamCaNhan ? Item.soCoViPhamCaNhan : 0}</td>
        <td className='txt-center'>{Item.soCoViPhanToChuc ? Item.soCoViPhanToChuc : 0}</td>
        <td className='txt-center'>{Item.soQDXuPhatHanhChinhTongSo ? Item.soQDXuPhatHanhChinhTongSo : 0}</td>
        <td className='txt-center'>{Item.soQDXuPhatHanhChinhCaNhan ? Item.soQDXuPhatHanhChinhCaNhan : 0}</td>
        <td className='txt-center'>{Item.soQDXuPhatHanhChinhToChuc ? Item.soQDXuPhatHanhChinhToChuc : 0}</td>

        <td className='txt-right'>{Item.soTienViPhamTongSo ? Item.soTienViPhamTongSo :0}</td>
        <td className='txt-right'>{Item.soTienViPhamCaNhan ? Item.soTienViPhamCaNhan : 0}</td>
        <td className='txt-right'>{Item.soTienViPhamToChuc ? Item.soTienViPhamToChuc : 0}</td>
        <td className='txt-right'>{Item.soTienKienNghiThuHoi ? Item.soTienKienNghiThuHoi : 0}</td>
        <td className='txt-right'>{Item.soTienXuLyTaiSanTongSo ? Item.soTienXuLyTaiSanTongSo : 0}</td>

        <td className='txt-right'>{Item.soTienXuLyTaiSanTichThu ? Item.soTienXuLyTaiSanTichThu : 0}</td>
        <td className='txt-right'>{Item.soTienXuLyTaiSanTieuHuy ? Item.soTienXuLyTaiSanTieuHuy : 0}</td>
        <td className='txt-right'>{Item.soTienXuLyViPhamTongSo ? Item.soTienXuLyViPhamTongSo : 0}</td>
        <td className='txt-right'>{Item.soTienXuLyViPhamCaNhan ? Item.soTienXuLyViPhamCaNhan : 0}</td>
        <td className='txt-right'>{Item.soTienXuLyViPhamToChuc ? Item.soTienXuLyViPhamToChuc : 0}</td>

        <td className='txt-right'>{Item.soTienDaThuTongSo ? Item.soTienDaThuTongSo :0}</td>
        <td className='txt-right'>{Item.soTienDaThuCaNhan ? Item.soTienDaThuCaNhan : 0}</td>
        <td className='txt-right'>{Item.soTienDaThuToChuc ? Item.soTienDaThuToChuc : 0}</td>

        <td className='ghi-chu'>{Item.ghiChu ? Item.ghiChu : ''}</td>
      </tr>
    );
  }
}

export default ListItemThongKeThanhTraChuyenNganh;



// WEBPACK FOOTER //
// ./src/components/modules/thong-ke-bao-cao/datatable/ListItemThongKeThanhTraChuyenNganh.jsx